import React from "react";
import { useLang } from "../i18n";

const STORY_IMG = "/images/story_sunset.jpg";

export default function AboutGuide() {
  const { t } = useLang();
  return (
    <section id="story" data-testid="about-guide" className="relative py-28 md:py-40 bg-[#F1E6D6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-14 md:gap-20 items-center">
        <div className="md:col-span-6">
          <p className="text-xs uppercase tracking-[0.28em] text-[#5E7891] mb-6">{t.guide.eyebrow}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.04] text-[#2D3640]">{t.guide.title}</h2>
          <p data-testid="guide-quote" className="font-script text-2xl md:text-3xl text-[#5E7891] mt-7 leading-snug">{t.guide.quote}</p>
          <p className="mt-7 text-base md:text-lg text-[#4A5A6B] leading-relaxed max-w-xl">{t.guide.body}</p>
        </div>
        <div className="md:col-span-6">
          <figure className="relative aspect-[4/5] rounded-[28px] overflow-hidden border border-[#E5D9C0] shadow-[0_40px_100px_-45px_rgba(132,118,137,0.5)]">
            <img src={STORY_IMG} alt="Sunset over the Douro and the Dom Luís bridge" loading="lazy" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D3640]/20 via-transparent to-transparent" />
          </figure>
        </div>
      </div>
    </section>
  );
}
